export default __webpack_public_path__ + "static/Planning a session-901902d84b1696b4eb004e666ccddef6.mp4";